import { render } from "./NavigationContainer.vue?vue&type=template&id=65c77642&scoped=true"
const script = {}

import "./NavigationContainer.vue?vue&type=style&index=0&id=65c77642&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c77642"]])

export default __exports__